import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M4.92,11.16a1.25,1.25,0,0,0,1.76,1.77l3.55-3.55a.26.26,0,0,1,.35,0l.94.94a.71.71,0,0,0,.53.22,1,1,0,0,0,.29,0,.75.75,0,0,0,.46-.7v-4A.76.76,0,0,0,12.05,5h-4a.74.74,0,0,0-.69.46.73.73,0,0,0,.16.82l.94.94a.25.25,0,0,1,0,.36Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M15.85,12.57a1,1,0,0,0,1.7-.71V3.29a3,3,0,0,0-3-3h-11a3,3,0,0,0-3,3v15.5a3,3,0,0,0,3,3h9.5a1,1,0,1,0,0-2H3.55a1,1,0,0,1-1-1V3.29a1,1,0,0,1,1-1h11a1,1,0,0,1,1,1v8.57A1,1,0,0,0,15.85,12.57Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M23.42,23.58a.27.27,0,0,0,0-.26L22,21.21a.23.23,0,0,1,0-.14V15.24c0-1.33-1.18-2.64-2.47-3.73a.26.26,0,0,0-.27,0,.26.26,0,0,0-.14.22v3.59a3.3,3.3,0,0,1-.47,1,.73.73,0,0,1-.53.22.77.77,0,0,1-.53-.21l-2.9-2.86-.07-.05A1.37,1.37,0,0,0,13,13.7a1.54,1.54,0,0,0,0,1.94h0l3.66,4.14a.23.23,0,0,1,.06.16V22.5a2.66,2.66,0,0,0,.31,1.07.26.26,0,0,0,.22.14H23.2A.25.25,0,0,0,23.42,23.58Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }